// @ts-nocheck
import { apiClient } from '@/api/client'
import { VESTOLIO_FULL_LOGO } from '@/lib/branding'
import ForgotPasswordForm from '@/components/common/ForgotPasswordForm'

export default function ForgotPasswordPage() {
  return (
    <ForgotPasswordForm
      portalName="Vestolio"
      logoUrl={VESTOLIO_FULL_LOGO}
      logoAlt="Vestolio"
      loginUrl="/login"
      minPasswordLength={8}
      emailPlaceholder="you@firm.com"
      variant="light"
      brandingHeadline={
        <h1 className="text-4xl xl:text-5xl font-bold text-white leading-[1.15] mb-6">
          Reset your<br />password<br />
          <span style={{ color: '#7eb3ff' }}>securely.</span>
        </h1>
      }
      brandingSubtitle="A modern platform for advisors who want to deliver exceptional, data-driven outcomes."
      footerNote="Access is by invitation only. · support@vestolio.com"
      onSendCode={async (email) => {
        await apiClient.post('/auth/forgot-password', { email })
      }}
      onResetPassword={async (email, code, newPassword) => {
        await apiClient.post('/auth/confirm-forgot-password', { email, code, newPassword })
      }}
    />
  )
}
